import axios from "axios";
import qs from "qs";

import { api } from "@/plugins/util";

/**
 * 根据类型查找文件
 * @param code
 * @param pageNum
 * @param pageSize
 */
export function getListByCode(code, pageNum, pageSize) {
    return axios.get(api + "/file/findByCode",
        {
            params: {
                code,
                pageNum,
                pageSize
            }
        })
}

/**
 * 上传文件
 * @param code      类型
 * @param path      路径
 * @param remark    备注
 */
export function uploadFileJS(code, path, remark) {
    return axios.post(api + "/file/uploadFile",
        {
            code,
            path,
            remark
        }
    )
}
